import selectedCompo_Reducer from './componentSelection'
import assemblySelec_Reducer from './assemblySelection'
import assemblyTwoSelec_Reducer from './assemblyTwoSelection'
import logicSelection from './logicSection'
import logicSelectionTwo from './logicSectionTwo'
import logicSelectionTwoContent from './logicSectionTwoContent'
import hexStateReducer from './hexState'
import flowlogicSelection from './flowLogic'
import packageJson from '../../../package.json'
import webSerialPortList_Reducer from './WebSerial'
import { combineReducers } from 'redux'
import popUpModalReducer from './popUpModalReducer'
import graphPlotStorage_Reducer from './graphPlotStorage'
import workerReducer from './worker'
import deviceReducer from './device'
import Connection_Reducer from './Connection'
import appModeStorage_Reducer from './appModeStorage'
import appAiModeStorage_Reducer from './appAiModeStorage'
import socketReducer from './socketStorage'
import navigationReducer from './navigation'
if (!packageJson['dev']) {
    console.log = function () {}
    console.warn = function () {}
}
const allReducer = combineReducers({
    webSerial: webSerialPortList_Reducer,
    concept: selectedCompo_Reducer,
    assembly: assemblySelec_Reducer,
    assemblyTwo: assemblyTwoSelec_Reducer,
    logic: logicSelection,
    logicTwo: logicSelectionTwo,
    logicTwoContent: logicSelectionTwoContent,
    hexState: hexStateReducer,
    flowlogic: flowlogicSelection,
    popUpModal: popUpModalReducer,
    graphPlotStorage: graphPlotStorage_Reducer,
    appAiModeStorage: appAiModeStorage_Reducer,
    // assemblyPageAi: assemblyPageAi_Reducer,
    worker: workerReducer,
    device: deviceReducer,
    isConnecting: Connection_Reducer,
    appModeStorage: appModeStorage_Reducer,
    socketData: socketReducer,
    navigation: navigationReducer,
})

export default allReducer
